import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { FreightModel } from 'src/app/models/management/freight.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FreightService {

  constructor(private _httpClient: HttpClient) { }

  createFreight(freightContract: FreightModel): Observable<FreightModel> {
    return this._httpClient.post<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.CreateAsync}`,
      freightContract);
  }

  deleteFreight(freightId: number): Observable<FreightModel> {
    return this._httpClient.delete<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.DeleteAsync}/${freightId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllConceptsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetAllConceptsForSelectAsync}`);
  }

  getAllFreightsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetAllFreightsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getFreightByConstructionSite(constructionSiteId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('constructionSiteId', constructionSiteId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetFreightByConstructionSiteAsync}`,
      { params: params }
    );
  }

  getFreightById(freightId: number): Observable<FreightModel> {
    const params = new HttpParams().set('freightId', freightId);
    return this._httpClient.get<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetByIdAsync}`,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetColumnsForGeneralConsultationAsync}`);
  }

  getFreightColumnsForConstructionSite(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetFreightColumnsForConstructionSiteAsync}`);
  }

  hasFreights(constructionSiteId: number): Observable<boolean> {
    const params = new HttpParams().set('constructionSiteId', constructionSiteId);
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.HasFreightsAsync}`,
      { params: params }
    );
  }

  getFreightByDocumentRental(costCenterId: number, vehicleId: number): Observable<FreightModel> {
    return this._httpClient.get<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetFreightByDocumentRental}/${costCenterId}/${vehicleId}`);
  }

  getFreightByKeys(cityOriginId: number, cityDestinyId: number, sectorId: number | null, conceptId: number, constructionSiteId: number | null): Observable<FreightModel> {
    let params = new HttpParams();
    params = params.set('cityOriginId', cityOriginId);
    params = params.set('cityDestinyId', cityDestinyId);
    params = params.set('conceptId', conceptId);
    if (sectorId !== null) {
      params = params.set('sectorId', sectorId.toString());
    }
    if (constructionSiteId !== null) {
      params = params.set('constructionSiteId', constructionSiteId.toString());
    }

    return this._httpClient.get<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.GetFreightByKeys}`,
      { params: params }
    );
  }

  updateFreight(freightContract: FreightModel): Observable<FreightModel> {
    return this._httpClient.put<FreightModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.freight.UpdateAsync}`,
      freightContract);
  }
}
